export function setCacheData(key, value, ttl = 1000 * 60 * 60 * 6) {
  const payload = {
    data: value,
    timestamp: Date.now(),
    ttl: ttl,
  };
  localStorage.setItem(key, JSON.stringify(payload));
}

export function getCacheData(key) {
  const cached = localStorage.getItem(key);
  if (!cached) return null;

  try {
    const { data, timestamp, ttl } = JSON.parse(cached);
    const isValid = Date.now() - timestamp < ttl;
    return isValid ? data : null;
  } catch (err) {
    console.warn("Erro ao ler cache:", err);
    return null;
  }
}
